import { Entry } from '../Entry'

export function Entry20240619() {
  return (
    <Entry title="19/06/2024 - v3.7.6">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/15917/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
